export enum UserTypeEnum {
  SHIPPER = 1,
  TRANSPORTER,
  HYBRID,
}
